import { useState } from "react";
import PropTypes from "prop-types";
import { Button, TextInput } from "@tremor/react";

export const SendMessage = ({ sendMessage = () => {} }) => {
  const [message, setMessage] = useState("");

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleSendMessage = () => {
    const trimmedMessage = message.trim();
    if (trimmedMessage === "") return;
    sendMessage(trimmedMessage);
    setMessage("");
  };

  return (
    <div className="fixed bottom-2 flex w-main-menu p-2 rounded">
      <TextInput
        value={message}
        onChange={(event) => setMessage(event.target.value)}
        placeholder="Escribir Mensaje..."
        onKeyDown={handleKeyDown}
      />
      <Button className="ml-2" onClick={handleSendMessage}>
        Enviar
      </Button>
    </div>
  );
};

SendMessage.propTypes = {
  sendMessage: PropTypes.func.isRequired,
};
